import React from "react";
import { WidgetPage } from "app/layout/WidgetPage/WidgetPage";
import { serverConfig, clientConfig } from "app/config";
import { StreamList } from "app/stream/StreamList/StreamList";
import { createStore, getJsonFromUrl } from "app/main/functions";
import { QuickSearchFieldContainer } from "app/search/QuickSearchFieldContainer/QuickSearchFieldContainer";
import { PageDataProvider } from "app/main/PageDataProvider";
import { Store } from "app/main/DataProvider";
import { StreamListItemProps } from "app/stream/StreamListItem/StreamListItem";
import { setSentryContext } from "app/sentry/ssr";
import { GetServerSidePropsContext } from "next";

interface StreamWidgetProps {
    items: StreamListItemProps[];
    url: string;
    store: Store;
}

function WidgetPageRoot({ items, store, url }: StreamWidgetProps) {
    if (!items) {
        return null;
    }

    return (
        <WidgetPage>
            <PageDataProvider value={store}>
                <QuickSearchFieldContainer widgetMode />
                <StreamList linkButtonUrl={url} linkButtonTitle="Börse & Märkte" items={items} />
            </PageDataProvider>
        </WidgetPage>
    );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
    setSentryContext(context);
    const url = `${serverConfig.apiURL}/marketoverview`;
    const marketOverViewUrl = clientConfig.marketOverViewUrl;
    const store = createStore(null, "", clientConfig);
    return {
        props: {
            items: await getJsonFromUrl(url),
            url: marketOverViewUrl,
            store
        }
    };
}

export default WidgetPageRoot;
